module.exports = __webpack_public_path__ + "static/media/block-1-bg.685b25e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/block-1-bg.png
// module id = 260
// module chunks = 270